import { useEffect } from 'react'

/**
 * Escape schließt das Blatt, das gerade obenauf liegt.
 *
 * Aus der Codereview (0.29.0): derselbe Zuhörer stand neunmal da, Zeichen
 * für Zeichen. Ein Blatt, das nur auf das X hört, ist am Rechner eine
 * Sackgasse; deshalb hat jedes ihn, und deshalb steht er jetzt einmal hier.
 *
 * `null` schaltet ihn ab: die Rückfrage hört nur, solange eine Frage offen
 * ist. Beide Zuhörer hängen an `window`, da steigt nichts auf; wer über
 * einem Blatt ein zweites öffnet, das Escape selbst braucht, sperrt
 * ausdrücklich (`stopPropagation` hilft hier nicht, siehe CLAUDE.md).
 */
export function useEscape(zu: (() => void) | null): void {
  useEffect(() => {
    if (zu === null) return
    const taste = (event: KeyboardEvent) => {
      if (event.key === 'Escape') zu()
    }
    window.addEventListener('keydown', taste)
    return () => window.removeEventListener('keydown', taste)
  }, [zu])
}
